var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel", attrs: { id: "panel-4" } }, [
    _c("div", { staticClass: "panel-hdr bg-danger-800 bg-success-gradient" }, [
      _c("h2", [
        _vm._v("\n            " + _vm._s(_vm.__t("LIST")) + "\n            "),
        _c("span", { staticClass: "fw-300" }, [
          _c("i", [_vm._v(_vm._s(_vm.__t("ACTION_GROUPS")))]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "panel-container show pt-1 pb-1" }, [
      _c(
        "div",
        { staticClass: "panel-content" },
        [
          _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
            _c("div", { staticClass: "rounded" }, [
              _vm.worked_groups.length > 0
                ? _c(
                    "ul",
                    { staticClass: "nav-menu mb-sm-4 mb-md-0 rounded" },
                    _vm._l(_vm.worked_groups, function (group) {
                      return _c("li", { key: group.id }, [
                        _c(
                          "a",
                          {
                            staticClass: "waves-effect waves-themed",
                            class: { active_filter: _vm.is_active_item(group) },
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.setActive(group)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "nav-link-text color-black" },
                              [
                                _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "position-relative" },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(
                                            _vm.__t(group.title.toUpperCase())
                                          ) +
                                          "\n\n                                            "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "small text-info" },
                                        [
                                          group.skeep_sync
                                            ? _c("i", {
                                                staticClass: "fal fa-lock",
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-icon btn-sm btn-success shadow-0 rounded-circle waves-effect waves-themed",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.add_action(group.id)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "fal fa-plus" })]
                            ),
                          ]
                        ),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticClass:
                  "filter-message js-filter-message m-0 text-left pl-4 py-3 fw-500",
              }),
            ]),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }